// @flow

import type { ExternalPayProviderBankList, PaymentOption } from './payment-option/types';
import type { CheckoutPaymentOptionsV2 } from '@tectonics/prs/incoming-payment';

export function getSafeAchPseBankList(paymentOptions: ImmutableArray<PaymentOption> | CheckoutPaymentOptionsV2): ExternalPayProviderBankList {
  if (!Array.isArray(paymentOptions) && Array.isArray(paymentOptions.achpse_bank_list)) {
    return paymentOptions.achpse_bank_list;
  }

  throw new Error('Bank List: bank list not found for PSE Avanza');
}
